import React from 'react';
const IconActionEditCircle = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16.8375 9.24552C17.0542 9.02888 17.0542 8.67893 16.8375 8.4623L15.5377 7.16248C15.3211 6.94584 14.9711 6.94584 14.7545 7.16248L13.738 8.179L15.821 10.262L16.8375 9.24552ZM7 14.917V17H9.08304L15.2266 10.8564L13.1436 8.77337L7 14.917Z" fill="#666666"/>
</svg>
);
};
export default IconActionEditCircle;